import { ElementStatus } from '@wix/rules-panel-ui';
import { useCallback, useRef } from 'react';
export const useImageElementsOrder = () => {
  const elementsOrderRef = useRef([]);
  const sortImages = useCallback((images, getEntityId) => {
    const sortedImages = Object.values(images.reduce((acc, img) => {
      const entityId = (getEntityId == null ? void 0 : getEntityId(img.id)) ?? img.entityId;
      // primary sort by products with at least one failed image
      acc[entityId] = acc[entityId] || {
        hasFailed: false,
        images: []
      };
      if (img.status === ElementStatus.Failed) {
        acc[entityId].hasFailed = true;
      }
      acc[entityId].images.push(img);
      return acc;
    }, {})).sort((a, b) => Number(b.hasFailed) - Number(a.hasFailed))
    // secondary sort by image status within the product
    .flatMap(group => group.images.sort((x, y) => Number(x.status === ElementStatus.Passed) - Number(y.status === ElementStatus.Passed)));
    elementsOrderRef.current = sortedImages.map(img => img.id);
    return sortedImages;
  }, []);
  const applyPreservedSortOrder = useCallback(images => {
    const idOrderMap = new Map();
    elementsOrderRef.current.forEach((id, index) => {
      idOrderMap.set(id, index);
    });
    return [...images].sort((a, b) => {
      const indexA = idOrderMap.get(a.id);
      const indexB = idOrderMap.get(b.id);
      if (indexA === undefined && indexB === undefined) {
        return 0;
      }
      if (indexA === undefined) {
        return 1;
      }
      if (indexB === undefined) {
        return -1;
      }
      return indexA - indexB;
    });
  }, []);
  const getOrderedImageElements = useCallback((altImageProps, getEntityId) => elementsOrderRef.current.length > 0 ? applyPreservedSortOrder(altImageProps) : sortImages(altImageProps, getEntityId), [applyPreservedSortOrder, sortImages]);
  return {
    getOrderedImageElements
  };
};
//# sourceMappingURL=use-image-elements-order.js.map